<template>
  <div id="#the-footer">
    <hr />
    <div class="footer-index-container row gy-3">
      <div class="col-md-6 footer-index-left">
        <h3>ติดต่อผ่านช่องทางออนไลน์</h3>
        <p>
          <a v-bind:href="`https://line.me/R/ti/p/${getLineId}`" target="_blank" rel="noopener" class="link-light"
            style="font-size: 1rem; color: rgb(0, 207, 46);">Line : Galaxy56</a>
        </p>
        <div class="footer-group-ic-social d-flex flex-wrap">
          <a v-bind:href="`https://line.me/R/ti/p/${getLineId}`" target="_blank" rel="noopener" class="mx-1">
            <img src="/static/img/social/line.png" alt="" class="social-icon" style="max-width: 60px;" />
          </a>
        </div>
      </div>
      <div class="footer-index-right col-md-6 text-center d-flex flex-column align-items-center justify-content-center">
        <h3>ฝาก-ถอน อัตโนมัติ</h3>
        <p class="mb-1">ตลอด 24 ชั่วโมง</p>
        <div class="d-flex footer-ic-bank">
          <img class="img-thumbnail social-icon" src="/static/img/bank-logo/baac.svg" alt="" />
          <img class="img-thumbnail social-icon" src="/static/img/bank-logo/bay.svg" alt="" />
          <img class="img-thumbnail social-icon" src="/static/img/bank-logo/bbl.svg" alt="" />
          <img class="img-thumbnail social-icon" src="/static/img/bank-logo/kbank.svg" alt="" />
          <img class="img-thumbnail social-icon" src="/static/img/bank-logo/ktb.svg" alt="" />
          <img class="img-thumbnail social-icon" src="/static/img/bank-logo/scb.svg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import CashBackForm from "@/components/form/CashBackForm";
import PromotionForm from "@/components/form/PromotionForm";
import WheelForm from "@/components/form/WheelForm";
import AfForm from "@/components/form/AfForm";
import WithdrawForm from "@/components/form/WithdrawForm";
import DepositForm from "@/components/form/DepositForm";
import HistoryForm from "@/components/form/HistoryForm";
import ProfileForm from "@/components/form/ProfileForm";
import MemberCard from "@/components/form/MemberCard";
export default {
  name: "Footer",
  data() {
    return {
      isShowNav: true,
      nowPage: this.$route.name,
    };
  },
  components: {
    CashBackForm,
    PromotionForm,
    WheelForm,
    AfForm,
    WithdrawForm,
    DepositForm,
    HistoryForm,
    ProfileForm,
    MemberCard,
  },
  computed: {
    ...mapGetters(["getLineId", "appTitle"]),
  },
  watch: {
    $route() {
      this.nowPage = this.$route.name;
      this.isShowNav = true;
      if (
        this.$route.name == "Login" ||
        this.$route.name == "Profile" ||
        this.$route.name == "Signup" ||
        this.$route.name == "Join"
      ) {
        return (this.isShowNav = false);
      }
    },
  },
  mounted() {
    this.nowPage = this.$route.name;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/layout/Footer.vue